var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-major-plan bjStyle" }, [
    _c(
      "div",
      { staticClass: "box majorPlan" },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c("el-tab-pane", { attrs: { label: "专业计划", name: "first" } }, [
              _c(
                "div",
                { staticClass: "majorPlan-table" },
                [
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.tableData.student_type == 1
                          ? "认定学分课程"
                          : "专业基础课"
                      )
                    ),
                  ]),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        "header-cell-style": {
                          background: "#eef1f6",
                          color: "#606266",
                        },
                        data: _vm.tableData.recognize,
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "code",
                          label: "课程代码",
                          width: "180",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "title", label: "课程名称" },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "学分", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                scoped.row.credit
                                  ? _c("span", [
                                      _vm._v(_vm._s(scoped.row.credit) + "分"),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "title", label: "学期" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                _vm._v(" " + _vm._s(scoped.row.semester) + " "),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { label: "课程总成绩", width: "150" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                !scoped.row.is_assess
                                  ? _c("span", [_vm._v("无考核")])
                                  : _c("div", [
                                      scoped.row.score_total
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scoped.row.score_total) +
                                                "分"
                                            ),
                                          ])
                                        : _c("span", [
                                            _vm._v("以考试成绩为准"),
                                          ]),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: { prop: "enableTime", label: "课程成绩构成" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scoped) {
                              return [
                                !scoped.row.is_assess
                                  ? _c("span", [_vm._v("-")])
                                  : _c("div", [
                                      scoped.row.score_usual
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 平时成绩：" +
                                                  _vm._s(
                                                    scoped.row.score_usual
                                                  ) +
                                                  "% "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      scoped.row.class_hours
                                        ? _c("p", [
                                            _vm._v(
                                              " 听课学时：" +
                                                _vm._s(scoped.row.class_hours) +
                                                "% "
                                            ),
                                          ])
                                        : _vm._e(),
                                      scoped.row.score_line
                                        ? _c(
                                            "p",
                                            {
                                              staticStyle: {
                                                "margin-right": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " 考试成绩：" +
                                                  _vm._s(
                                                    scoped.row.score_line
                                                  ) +
                                                  "% "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("h2", [
                    _vm._v(
                      _vm._s(
                        _vm.tableData.student_type == 1
                          ? "国家统考课程"
                          : "公共课"
                      )
                    ),
                  ]),
                  _vm.tableData.student_type == 1
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": {
                              background: "#eef1f6",
                              color: "#606266",
                            },
                            data: _vm.tableData.exam_course,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "code",
                              label: "课程代码",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "课程名称" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "学分", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      scoped.row.credit
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scoped.row.credit) + "分"
                                            ),
                                          ])
                                        : _c("span", [_vm._v("-")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1212601589
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tableData.student_type == 2
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": {
                              background: "#eef1f6",
                              color: "#606266",
                            },
                            data: _vm.tableData.exam_course,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "code",
                              label: "课程代码",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "课程名称" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "学分", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      scoped.row.credit
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scoped.row.credit) + "分"
                                            ),
                                          ])
                                        : _c("span", [_vm._v("-")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1212601589
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "学期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scoped.row.semester) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2981507635
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "课程总成绩", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      !scoped.row.is_assess
                                        ? _c("span", [_vm._v("无考核")])
                                        : _c("div", [
                                            scoped.row.score_total
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scoped.row.score_total
                                                    ) + "分"
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v("以考试成绩为准"),
                                                ]),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3945257930
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "enableTime",
                              label: "课程成绩构成",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      !scoped.row.is_assess
                                        ? _c("span", [_vm._v("-")])
                                        : _c("div", [
                                            scoped.row.score_usual
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 平时成绩：" +
                                                        _vm._s(
                                                          scoped.row.score_usual
                                                        ) +
                                                        "% "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scoped.row.class_hours
                                              ? _c("p", [
                                                  _vm._v(
                                                    " 听课学时：" +
                                                      _vm._s(
                                                        scoped.row.class_hours
                                                      ) +
                                                      "% "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            scoped.row.score_line
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 考试成绩：" +
                                                        _vm._s(
                                                          scoped.row.score_line
                                                        ) +
                                                        "% "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              866328669
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tableData.student_type == 2
                    ? _c("h2", { staticStyle: { "margin-top": "20px" } }, [
                        _vm._v("专业课"),
                      ])
                    : _vm._e(),
                  _vm.tableData.student_type == 2
                    ? _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "header-cell-style": {
                              background: "#eef1f6",
                              color: "#606266",
                            },
                            data: _vm.tableData.profession_course,
                            border: "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "code",
                              label: "课程代码",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "课程名称" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "学分", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      scoped.row.credit
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(scoped.row.credit) + "分"
                                            ),
                                          ])
                                        : _c("span", [_vm._v("-")]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1212601589
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { prop: "title", label: "学期" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      _vm._v(
                                        " " + _vm._s(scoped.row.semester) + " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2981507635
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "课程总成绩", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      !scoped.row.is_assess
                                        ? _c("span", [_vm._v("无考核")])
                                        : _c("div", [
                                            scoped.row.score_total
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scoped.row.score_total
                                                    ) + "分"
                                                  ),
                                                ])
                                              : _c("span", [
                                                  _vm._v("以考试成绩为准"),
                                                ]),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3945257930
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "enableTime",
                              label: "课程成绩构成",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scoped) {
                                    return [
                                      !scoped.row.is_assess
                                        ? _c("span", [_vm._v("-")])
                                        : _c("div", [
                                            scoped.row.score_usual
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 平时成绩：" +
                                                        _vm._s(
                                                          scoped.row.score_usual
                                                        ) +
                                                        "% "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            scoped.row.class_hours
                                              ? _c("p", [
                                                  _vm._v(
                                                    " 听课学时：" +
                                                      _vm._s(
                                                        scoped.row.class_hours
                                                      ) +
                                                      "% "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            scoped.row.score_line
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 考试成绩：" +
                                                        _vm._s(
                                                          scoped.row.score_line
                                                        ) +
                                                        "% "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              866328669
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _c(
              "el-tab-pane",
              { attrs: { label: "教材版本", name: "second" } },
              [_c("TextbookVersions")],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }